import { z } from 'zod';
import { FEATURE_FLAG, PAGINATION_SORT_DIRECTION } from '~/constants';

import { RouteExportParams } from '~/types/router.type';

import {
  ACCOUNTING_REFERENCE_SIGNATURE_RATES_BREAKDOWN_SORT_BY,
  SITE_SIGNATURE_RATES_BREAKDOWN_SORT_BY,
} from '~/data/analytics';

import {
  DATE_RANGE_OPTIONS,
  DELIVERY_NOTES_CHART_TYPE,
  USAGE_TABS,
} from '~/modules/analytics/usage';

import { toSnakeCase } from '@vestigas/utils';

export const zodAnalyticsSearchParamsSchema = z.object({
  costCenterSignatureRatesSortBy: z
    .preprocess(
      (value) => (typeof value === 'string' ? toSnakeCase(value) : value),
      z.enum(ACCOUNTING_REFERENCE_SIGNATURE_RATES_BREAKDOWN_SORT_BY),
    )
    .optional()
    .prefault('signature_rate')
    .catch('signature_rate'),
  costCenterSignatureRatesSortOrder: z
    .preprocess(
      (value) => (value ? String(value).toUpperCase() : undefined),
      z.enum(PAGINATION_SORT_DIRECTION),
    )
    .optional()
    .prefault('DESC')
    .catch('DESC'),
  dateRangeName: z
    .enum(Object.keys(DATE_RANGE_OPTIONS))
    .optional()
    .prefault('30-days')
    .catch('30-days'),
  deliveryNotesChartType: z
    .enum(DELIVERY_NOTES_CHART_TYPE)
    .optional()
    .prefault('relative')
    .catch('relative'),
  detailsTable: z.enum(USAGE_TABS).optional().prefault('users').catch('users'),
  page: z.coerce.number().int().nonnegative().optional().prefault(0).catch(0),
  searchString: z.string().trim().optional().prefault(''),
  siteSignatureRatesSortBy: z
    .preprocess(
      (value) => (typeof value === 'string' ? toSnakeCase(value) : value),
      z.enum(SITE_SIGNATURE_RATES_BREAKDOWN_SORT_BY),
    )
    .optional()
    .prefault('signature_rate')
    .catch('signature_rate'),
  siteSignatureRatesSortOrder: z
    .preprocess(
      (value) => (value ? String(value).toUpperCase() : undefined),
      z.enum(PAGINATION_SORT_DIRECTION),
    )
    .optional()
    .prefault('DESC')
    .catch('DESC'),
  tableSortBy: z
    .string()
    .trim()
    .optional()
    .transform((value) => (value ? toSnakeCase(value) : undefined)),
  tableSortOrder: z
    .preprocess(
      (value) => (value ? String(value).toUpperCase() : undefined),
      z.enum(PAGINATION_SORT_DIRECTION),
    )
    .optional(),
});

export const routeParams: RouteExportParams = {
  featureFlag: FEATURE_FLAG.ANALYTICS_USER,
  permissions: ['accounting_reference.', 'site.', 'user.'],
};
